export const topSectionStyles = {
  display: 'flex',
  gap: '24px',
};

export const topSectionCustomStyles = {
  flex: '1',
  padding: '10px 0 24px !important',
  '.title': {
    paddingInline: '10px',
  },

  '.divider': {
    margin: '10px 0 24px',
  },
  '.table-cell': {
    paddingTop: '10px',
    paddingBottom: '10px',
  },
  '.table-row': {
    '&:first-of-type': {
      '.table-cell': {
        paddingTop: '4px',
      },
    },
    '&:last-of-type': {
      '.table-cell': {
        paddingBottom: '3px',
      },
    },
  },
};

export const programDetailsWidthStyles = {
  width: '400px',
  maxWidth: '400px',
};

export const programDetailsCustomStyles = {
  ...programDetailsWidthStyles,
  ...topSectionCustomStyles,

  height: 'auto',

  '& span': {
    display: 'block',
    maxWidth: '170px',
  },
};

export const dividerStyles = {
  margin: '24px 0 60px',
};

export const loanDetailsStyles = {
  padding: '0 24px',
};

export const escrowBlockStyles = {
  marginTop: '48px',
  padding: '16px 12px',
  borderRadius: ({ shape }) => shape.radius.s,
};

export const escrowSwitchCustomStyles = {
  gap: '12px',

  '&::after': {
    right: '-7px',
  },
};

export const escrowDividerStyles = {
  margin: '16px 0 8px',
};

export const escrowTitleStyles = {
  marginBottom: '12px',
};

export const insuranceEscrowsContStyles = {
  marginTop: '8px',
  display: 'flex',
  flexWrap: 'wrap',
  columnGap: '58px',
  rowGap: '8px',
};

export const chattelRefinanceCaptionStyles = {
  display: 'block',
  marginTop: '8px',
};

export const dscrCaptionStyles = {
  display: 'block',
  marginTop: '4px',
};
